export default __webpack_public_path__ + "static/media/heroimagetwo.7b30755f.svg";